// extracted by mini-css-extract-plugin
module.exports = {"root":"Image_root__Jyd9M","img":"Image_img__vSCEn","desc":"Image_desc__OImRd"};